import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

const setIsSharedMailboxMutator: (isSharedMailbox: boolean, mailboxInfo: MailboxInfo) => void =
    mutatorAction(
        'SET_IS_SHARED_MAILBOX',
        (isSharedMailbox: boolean, mailboxInfo: MailboxInfo): void => {
            getStore(mailboxInfo).initialized = true;
            getStore(mailboxInfo).isSharedMailbox = isSharedMailbox;
        }
    );

export default setIsSharedMailboxMutator;
